<ng-container *ngIf="isVisible; else blank">
<div [ngClass]="blockClassName('section-header')" hide-empty>
  <ng-content select="[facet-header],f-facet[name=header]"></ng-content>
</div>
<div [ngClass]="blockClassName('section')" #slotContainer hide-empty>
  <ng-content select="w-slot,f-facet[name=slot],[facet-slot]"></ng-content>
  <ng-content select="f-facet[name=filter-actions],[facet-filter-actions]"></ng-content>
</div>
<div [ngClass]="blockClassName('section-footer')" hide-empty>
  <ng-content select="f-facet[name=footer],[facet-footer]"></ng-content>
</div>
</ng-container>
<!-- we hide empty sections, so add attribute show even if empty -->
<ng-template #blank><span w-not-empty></span></ng-template>